module.exports = __webpack_public_path__ + "static/img/solar-cells.d02480b.jpg";